import { render } from "./salaryRange.vue?vue&type=template&id=f4b018b0&ts=true"
import script from "./salaryRange.vue?vue&type=script&lang=ts"
export * from "./salaryRange.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__